export default "/images/global.png?d88dfc7e77080472faee3634da425a6d";